<template>
  <div v-if="showHeader">
    <div class="wim-header">
      <div :class="['wim-header-container', scrollDirection === 'down' ? 'collapsed' : '']">
        <div class="wim-volume" @click="toggleAudio">{{audioIsPlaying ? 'sound on' : 'sound off'}}</div>
        <div class="wim-menu">
          <span class="wim-header-text" @click="toggleMenu">menu</span>
        </div>
        <div class="wim-lang">
          <span :class="[this.$ml.current === 'IT' ? 'active' : '']" @click="changeLang('IT')">it</span><span class="wim-header-dot">·</span><span :class="[this.$ml.current === 'EN' ? 'active' : '' ]" @click="changeLang('EN')">en</span>
        </div>
      </div>
    </div>
    <transition name="slide">
      <div class="wim-menu-component" v-if="show">
        <Menu :content="content" :sectionIndex="sectionIndex" :onClick="toggleMenu"></Menu>
      </div>
    </transition>
  </div>
</template>
<script>
import { Howl } from "howler";
import Menu from "./Menu.vue";

export default {
  props: ["content", "sectionIndex"],
  mounted() {
    this.listenWindowScroll();
  },
  watch: {
    show(show) {
      console.log(show)
      document.querySelector('body').style.overflow = show ? 'hidden' : 'auto';
    },
    sectionIndex(value) {
      if (this.bgSound) {
        this.bgSound.pause();
        this.bgSound = null;
      }

      if (value === 6) {
        this.bgSound = new Howl({
          src: [`${this.baseUrl}audio/audio-bg.ogg`],
          autoplay: false,
          loop: true
        });
        if (this.audioIsPlaying) this.bgSound.play();
      }
    }
  },
  data() {
    return {
      show: false,
      audioIsPlaying: false,
      scrollPos: 0,
      scrollDirection: "up",
      baseUrl: process.env.BASE_URL,
      showHeader: true,
      bgSound: null
    };
  },
  methods: {
    changeLang(lang){
      this.$ml.change(lang);
      this.$router.push(lang === 'IT' ? '/IT' : '/EN');
    },
    toggleMenu() {
      this.show = !this.show;
    },
    toggleAudio() {
      let landingVideo = document.querySelector('#wim-landing-video-container video');
      if (this.audioIsPlaying) {
        landingVideo.muted = true;
        if (this.bgSound) this.bgSound.pause()
      } else {
        landingVideo.muted = false;
        if (this.bgSound) this.bgSound.play()
      }

      this.audioIsPlaying = !this.audioIsPlaying;
    },
    listenWindowScroll() {
      window.addEventListener("scroll", () => {
        if (this.$mq === "mobile" && document.body.getBoundingClientRect().top < 0) {          
          if (document.body.getBoundingClientRect().top > this.scrollPos) {
            this.scrollDirection = "up";
          } else {
            this.scrollDirection = "down";
          }
          this.scrollPos = document.body.getBoundingClientRect().top;
        } else {
          this.scrollDirection = "up";
        }
      });
    }
  },
  components: {
    Menu
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.wim-header-container {
  height: 50px;
  width: 100%;
  background: $white;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
  padding: 0 25px;
  transition: top 0.5s ease;
  img {
    background: transparent;
  }
  &.collapsed {
    top: -50px;
  }
  .wim-volume,
  .wim-menu,
  .wim-lang {
    font-family: "Nunito Sans", sans-serif;
    font-size: 14px;
    letter-spacing: 1.4px;
    font-weight: 900;
    text-transform: uppercase;
    color: $red;
    cursor: pointer;
    user-select: none;
    & span {
      width: fit-content;
      position: relative;
      &.active::after {
        content: "";
        height: 3px;
        width: 15px;
        border-bottom: solid 2px $red;
        position: absolute;
        top: 15px;
        left: calc(50% - 8px);
        transition: all 0.5s ease;
      }
      &::after {
        content: "";
        height: 3px;
        width: 0px;
        border-bottom: solid 2px $red;
        position: absolute;
        top: 15px;
        left: calc(50% - 10px);
        transition: all 0.5s ease;
      }
      &:hover::after {
        width: 15px;
      }
    }
  }
  .wim-lang {
    .wim-header-dot {
      font-size: 14px;
      margin: 0 5px;
      color: $red;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .wim-menu {
    position: absolute;
    left: calc(50% - 23px);
    top: calc(50% - 10px);
  }
}
.wim-menu-component {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background: $red;
  z-index: 8;
  transition: top 0.4s cubic-bezier(0.2, 0.25, 0.2, 1);
  &.slide-enter,
  &.slide-leave-to {
    top: -100vh;
    * {
      opacity: 0;
    }
  }
  * {
    transition: opacity 1s;
    transition-delay: 0.3s;
  }
}
@media (max-width: 768px) {
  .wim-header-container {
    width: 100vw;
    padding: 0 15px;
  }
}
</style>